import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const rootElement = document.getElementById("root");
const app = (
	<HelmetProvider>
		<App />
	</HelmetProvider>
);

// react-snap prerenders every route in the "routes" list (see package.json)
// to real static HTML at build time, via the "postbuild" script. That's
// what gives crawlers, link-unfurlers, and any non-JS client actual page
// content instead of an empty <div id="root"> — and lets Google index
// this content on the first pass instead of queuing it for a second,
// slower JS-rendering pass.
//
// When the prerendered HTML is what's loading, #root already has children
// on first paint, so we hydrate onto that existing markup instead of
// wiping it and rendering fresh (createRoot would tear it down first,
// causing a flash and defeating the point of prerendering it).
if (rootElement.hasChildNodes()) {
	ReactDOM.hydrateRoot(rootElement, app);
} else {
	const root = ReactDOM.createRoot(rootElement);
	root.render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
